// @ts-nocheck
import {Column} from 'react-table'
import {UserInfoCell} from './UserInfoCell'
import {UserTwoStepsCell} from './UserTwoStepsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'
import UserPhoneNumberCell from './UserPhoneNumberCell'
import UserGenderCell from './UserGenderCell'
import UserLocationCell from './UserLocationCell'
import {UserStatusCell} from './UserStatusCell'
import {UserActionsCell} from './UserActionsCell'

const usersColumns: ReadonlyArray<Column<User>> = [
  // {
  //   Header: (props) => <UserSelectionHeader tableProps={props} />,
  //   id: '_id',
  //   Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index]._id} />,
  // },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Name' className='min-w-125px' />,
    id: 'firstName',
    accessor: 'firstName',
    Cell: ({...props}) => <UserInfoCell user={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Phone' className='min-w-125px' />
    ),
    id: 'phone',
    accessor: 'phone',
    Cell: ({...props}) => <UserPhoneNumberCell phone={props.data[props.row.index].phone} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Email' className='min-w-125px' />
    ),
    id: 'email',
    accessor: 'email',
    Cell: ({...props}) => <UserGenderCell gender={props.data[props.row.index].email} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Available roles' className='min-w-125px' />
    ),
    id: 'role',
    accessor: 'role',
    Cell: ({...props}) => (
      <>
        {' '}
        {props.data[props.row.index].availableRoles.length > 0
          ? props.data[props.row.index].availableRoles.map((role, index) => (
              <p className='badge badge-light fw-bolder'>
                {role} {index === props.data[props.row.index].availableRoles.length - 1 ? '' : ','}
              </p>
            ))
          : 'N/A'}
      </>
    ),
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Status' className='min-w-125px' />
    ),
    id: 'isBlocked',
    accessor: 'isBlocked',
    Cell: ({...props}) => {
      const user = props.data[props.row.index]
      return (
        <UserStatusCell
          isBlocked={user.isBlocked}
          availableRoles={user.availableRoles}
          premium={user.premium}
          premium_request={user.premium_request}
        />
      )
    },
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Location' className='min-w-125px' />
    ),
    id: 'primaryLocation',
    accessor: 'primaryLocation',
    Cell: ({...props}) => <UserLocationCell phone={props.data[props.row.index].primaryLocation} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-125px' />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <UserActionsCell
        id={props.data[props.row.index]._id}
        role={props.data[props.row.index].role}
      />
    ),
  },
]

export {usersColumns}
